import stoneService from '@services/magento/stone.service';

import { Package, PackageDraftInput, Shipment, ShipmentDraftInput } from '@stone/interfaces';

/**
 * Server-side paginated slice of the draft shipment's root packages, returned
 * by `createDraftPackage` and `deleteDraftPackage` so the client can refresh
 * its list in the same round-trip. See §3.13 / §3.14 of the API doc.
 *
 * The query is fixed on the backend: `shipment_id=<current>`, `parent_id IS NULL`,
 * `page_size=20`, `current_page=1`, `sort package_id DESC`.
 */
export interface PackagesSearchResult {
  items: Package[];
  total_count: number;
  search_criteria?: any;
}

export interface DraftPackageResponse {
  shipment: Shipment;
  package: Package;
  labels?: Array<{ label_content?: string; display_format?: string }>;
  /** Populated on `createDraftPackage`; always `null` on `updateDraftPackage`. */
  packages_search_result?: PackagesSearchResult | null;
}

export interface DraftShipmentResponse {
  shipment: Shipment;
  /** Populated on `deleteDraftPackage`. */
  packages_search_result?: PackagesSearchResult | null;
}

export async function createDraftPackageApi(shipment: ShipmentDraftInput, pkg: PackageDraftInput): Promise<DraftPackageResponse> {
  return stoneService.createDraftPackage(shipment, pkg);
}

export async function updateDraftPackageApi(shipment: ShipmentDraftInput, pkg: PackageDraftInput): Promise<DraftPackageResponse> {
  return stoneService.updateDraftPackage(shipment, pkg);
}

export async function deleteDraftPackageApi(shipmentId: number | string, packageId: number | string): Promise<DraftShipmentResponse> {
  return stoneService.deleteDraftPackage(shipmentId, packageId);
}

export async function deleteAllDraftPackagesApi(shipmentId: number | string): Promise<DraftShipmentResponse> {
  return stoneService.deleteAllDraftPackages(shipmentId);
}
